export default "__VITE_ASSET__BjDjWG_9__"